export default "__VITE_ASSET__B63PkI$a__"